import React, {useState} from 'react';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ResultatValg } from '../Store/Resultat/Types';
import { VeilederSlettingAvRenterAppState } from '../Store/index';
import VeilederSlettingAvRenterDto from '../Models/VeilederSlettingAvRenterDto';

interface InntektOgBarnOwnProps {
    sporsmalId: string,
    onChangeHandler: any,
    valuta: string
    locale: string
}

type InntektOgBarnDisplayProps = InntektOgBarnOwnProps & MapStateToProps;

function InntektOgBarn(props: InntektOgBarnDisplayProps): JSX.Element {
    const { epiContext } = props;
    const [inntekt, setInntekt] = useState("0");
    const [antallBarn, setAntallBarn] = useState("0");
    const [erKollapset, setKollapset] = useState(false);
    const [startet, setStartet] = useState(false);

    function minusClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        if(antallBarn === "") {
            return;
        }

        if(parseInt(antallBarn) === 0)
            return;

        setAntallBarn((parseInt(antallBarn) - 1).toString());
    }

    function plussClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {

        if(antallBarn === "") {
            setAntallBarn("1");
            return;    
        }

        if(parseInt(antallBarn) === 9)
            return;

        setAntallBarn((parseInt(antallBarn) + 1).toString());
    }

    function inntektHandler(e: React.SyntheticEvent<HTMLInputElement>): void {

        if(e.currentTarget.value == "" || e.currentTarget.value == null || e.currentTarget.value == undefined) {
            setInntekt("");
            return;
        }

        //fjerner alle space og komma som er lagt på i visningen slik at tall blir lagret korrekt.
        let stringVal: string = e.currentTarget.value.replace(/[^0-9]/g,''); 

        let parsed: number = parseInt(stringVal);

        if(parsed > 9999999)
            return;

        if(!isNaN(parsed))
            setInntekt(parsed.toString());
    }

    function antallBarnHandler(e: React.SyntheticEvent<HTMLInputElement>): void {
        if(e.currentTarget.value == "" || e.currentTarget.value == null || e.currentTarget.value == undefined) {
            setAntallBarn("");
            return;
        }

        let parsed: number = parseInt(e.currentTarget.value);

        if(parsed > 9)
            return;

        if(!isNaN(parsed))
            setAntallBarn(parsed.toString());
    }

    function buttonClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        //e.preventDefault();
        
        if(!isNaN(parseInt(inntekt)) && !isNaN(parseInt(antallBarn))) {
            setStartet(true);
            toggleContainer();
            props.onChangeHandler(parseInt(inntekt), parseInt(antallBarn));
        } 
    }

    function formatNumber(tall: string, locale: string = 'nb-NO') : string {
        if(locale === 'en-US') {
            tall = tall.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
        } else {
            tall = tall.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        }
        return tall;
    }

    function handleExpandCollapse(e: React.SyntheticEvent):void  {
        e.preventDefault();
        
        if(!startet)
            return;

        toggleContainer();
    }

    function handleOnKeyUp(e: React.KeyboardEvent): void {
        if(!startet)
            return;

        if(e.key != "Enter")
            return;

        toggleContainer();
    }

    function toggleContainer(): void {
        
        if(inntekt == "" || antallBarn == "") 
            return;

        let cont = document.getElementById(props.sporsmalId);
        if(cont?.classList.contains("c-veileder__panel--uncollapsed")) {
            cont?.classList.remove("c-veileder__panel--uncollapsed");
            cont?.classList.add("c-veileder__panel--collapsed");    
            setKollapset(true);
        } else {
            cont?.classList.add("c-veileder__panel--uncollapsed");
            cont?.classList.remove("c-veileder__panel--collapsed");
            setKollapset(false);
        }
    }

    return (
            <div className="c-veileder__panel c-veileder__panel--uncollapsed c-veileder__panel--color" id={props.sporsmalId}>
                <div 
                    onClick={handleExpandCollapse} 
                    className="c-veileder__panel-row c-veileder__panel-row--clickable"
                    onKeyUp={handleOnKeyUp}
                    role={(!erKollapset && !startet ? undefined : "button")}
                    tabIndex={(!erKollapset && !startet ? undefined : 0)}
                    aria-expanded={(!erKollapset && !startet ? undefined : !erKollapset)}
                >
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder--overskrift c-veileder--overskrift-stor c-veileder--overskrift-uten-margin">
                            {contentResolver(epiContext, 'tittelToppB')}
                        </h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                        <div className="c-veileder__valgt-item">
                            <span className="c-veileder__tekst c-veileder__tekst--valg">
                                {formatNumber(inntekt, props.locale)}&nbsp;{props.valuta}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row c-veileder__panel-row--med-stor-margin">
                    <div className="c-veileder__content">
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'infotekstToppB')}
                        </div>
                    </div>
                    <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                        <div className="c-veileder__inputomrade ">
                            <label htmlFor={"js-slett-renter-inntekt"} id="f1-sporsmal" className="c-veileder__undersporsmal">
                                {contentResolver(epiContext, 'ledetekstBelopB')}
                            </label>
                            <div className="c-number-input c-number-input--big ">
                                <input onChange={inntektHandler} id="js-slett-renter-inntekt" aria-labelledby="f1-sporsmal" className="c-number-input__input" type="string" value={formatNumber(inntekt, props.locale)} />
                                <div className="c-number-input__postfix"><span>{props.valuta}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-ekstra-liten">{contentResolver(epiContext, 'tittelBunnB')}</h4>
                    </div>
                </div>
                <div className="c-veileder__panel-row c-veileder__panel-row--med-stor-margin">
                    <div className="c-veileder__content">
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'infotekstBunnB')}
                        </div>
                    </div>
                    <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                        <div className="c-veileder__inputomrade ">
                            <h3 id="a-antall-barn-sporsmal" className="c-veileder__undersporsmal">
                                {contentResolver(epiContext, 'ledetekstBarnB')}
                            </h3>
                            <div className="c-number-input c-number-input--minmax">
                                <button onClick={minusClickHandler} className="c-number-input__button c-number-input__button--sub">-</button>
                                <input  onChange={antallBarnHandler} id="js-slett-renter-antall-barn" aria-labelledby="a-antall-barn-sporsmal" className="c-number-input__input c-number-input__input--minmax" type="number" value={antallBarn} />
                                <button onClick={plussClickHandler} className="c-number-input__button c-number-input__button--add">+</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row--med-stor-margin"></div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--textarea c-veileder--skjult-for-mobil">&nbsp;</div>
                    <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                        <button onClick={buttonClickHandler} className="c-knapp c-knapp--cta c-knapp--primary">{contentResolver(epiContext, 'knappetekstB')}</button>
                    </div>
                </div>
            </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederSlettingAvRenterAppState, ownProps: InntektOgBarnOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    },
)(InntektOgBarn);